import { connect } from 'react-redux';
import { PriceBlockComponent } from '../../../price-block';
import { priceBlockSelector } from '../../../../../../../../redux/product/product.selectors';
import { priceBlockDispatcher } from '../../../../../../../../redux/product/product.dispatchers';
export const PriceBlock = connect(priceBlockSelector, priceBlockDispatcher)(PriceBlockComponent);